var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-section.ts
import { customElement } from "lit/decorators.js";
import "./x-flex.js";
import { XFlex } from "./x-flex.js";
var XSection = class extends XFlex {
  styles() {
    return [
      ...super.styles(),
      {
        width: "100%",
        margin: "0 auto",
        padding: `0 ${this.spacing.md}`,
        maxWidth: this.sizes.maxPageWidth
      }
    ];
  }
};
XSection = __decorateClass([
  customElement("x-section")
], XSection);
export {
  XSection
};
